// extracted by mini-css-extract-plugin
export var contentBackground = "contentBackground-module--contentBackground--PsAza";
export var contentBackgroundPlaying = "contentBackground-module--contentBackgroundPlaying--yvg6U contentBackground-module--contentBackground--PsAza";
export var contentVideo = "contentBackground-module--contentVideo--zc0mm";
export var contentImage = "contentBackground-module--contentImage--FLfox";
export var slideUp = "contentBackground-module--slideUp--25itx";
export var slideUpLarge = "contentBackground-module--slideUpLarge--az4Bq";